export const isUserCreatedBeforeAgreementDate = currentUser => {
  const userCreatedAt = currentUser?.attributes?.createdAt;
  const newAgreementDateStr = process.env.REACT_APP_NEW_AGREEMENT_DATE;

  if (!newAgreementDateStr || !userCreatedAt) {
    return false;
  }

  const newAgreementDate = new Date(newAgreementDateStr);
  const userCreatedDate = new Date(userCreatedAt);

  if (isNaN(newAgreementDate.getTime()) || isNaN(userCreatedDate.getTime())) {
    console.error("Invalid date format detected for agreement comparison.");
    return false;
  }

  return userCreatedDate < newAgreementDate;
};